import { AdminClassroomLayout } from "@/pages/admin/AdminClassroomLayout";
import { StudentHomeworkDetailPage } from "@/pages/teacher/StudentHomeworkDetailPage";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/admin/classrooms/$classroomId/students/$studentId/homework/$homeworkId"
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { classroomId, studentId, homeworkId } = Route.useParams();
  return (
    <AdminClassroomLayout>
      <StudentHomeworkDetailPage
        classroomId={classroomId}
        studentId={studentId}
        homeworkId={homeworkId}
        scope="admin"
      />
    </AdminClassroomLayout>
  );
}
